export default __webpack_public_path__ + "static/tsilva-f04ccf2f5d5b006383e7c2b1e393d46a.jpeg";